import Base from "../../base";
import SideMenu from "../SideMenu";
import LeftMenu from "../../../components/LeftMenu";
import Header from "../Header";
import axiosConfig from "../../../services/Axios";
import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import FieldError from "../../../components/ui/FieldError";
import RequiredField from "../../../components/ui/RequiredField";
import { useTranslation } from "react-i18next";
import Button from "../../../components/ui/Button";
import { toast } from "react-toastify";
import ContactsList from "./ContactsList";
import AddressList from "./AddressList";
import Title from "../../../components/ui/Title";
import { useSelector } from "react-redux";
import { pickBy } from "lodash";

function PartnersForm() {
  const { id } = useParams();
  const [partner, setPartner] = useState();
  const authUser = useSelector((state) => state.auth);
  const form = useForm();
  const { t } = useTranslation();

  useEffect(() => {
    axiosConfig
      .get(process.env.REACT_APP_API_URL + "/api/partners/" + id)
      .then((response) => {
        if (response?.status === 200 && response?.data) {
          setPartner(response.data);
        }
      });
  }, []);

  const onSubmitPartner = async (data) => {
    try {
      await axiosConfig
        .patch(process.env.REACT_APP_API_URL + partner["@id"], data, {
          headers: { "Content-Type": "application/merge-patch+json" },
        })
        .then((response) => {
          if (response?.status === 200 && response?.data) {
            setPartner(response.data);
            toast.success(t("global.changes_saved"), {
              theme: "colored",
              hideProgressBar: true,
            });
          }
        });
    } catch (e) {
      if (e.response.status !== 200 && e.response.data?.violations) {
        e.response.data.violations.map((v) => {
          form.setError(v.propertyPath, {
            type: "manual",
            message: v.message,
          });
        });
      }
    }
  };

  return (
    <Base>
      <Header />
      <div className="py-16 container m-auto px-6 grid grid-cols-12">
        <div className="col-span-12 lg:col-span-3 xl:col-span-2">
          <LeftMenu menu={SideMenu} />
        </div>
        <div className="lg:ml-6 text-sm mt-10 lg:mt-0 col-span-12 lg:col-span-9 xl:col-span-10">
          {partner && (
            <>
              <div className="lg:p-8 lg:px-10 lg:bg-white rounded-lg">
                <Title title={partner.name.toUpperCase()} />

                <div>
                  <form onSubmit={form.handleSubmit(onSubmitPartner)}>
                    <div className="grid grid-cols-12 gap-3">
                      <div className="col-span-12">
                        <label>
                          {t("partner.raison_soc")} <RequiredField /> :
                        </label>
                        <input
                          {...form.register("name")}
                          name="name"
                          type="text"
                          className="w-full"
                          defaultValue={partner.name}
                          aria-invalid={
                            form.formState?.errors?.name ? true : false
                          }
                        />
                        <FieldError error={form.formState?.errors?.name} />
                      </div>

                      <div className="col-span-12 xl:col-span-6">
                        <label>{t("partner.siren_number")} :</label>
                        <input
                          {...form.register("sirenNumber")}
                          name="sirenNumber"
                          type="text"
                          className="w-full"
                          defaultValue={partner.sirenNumber}
                          aria-invalid={
                            form.formState?.errors?.sirenNumber ? true : false
                          }
                        />
                        <FieldError
                          error={form.formState?.errors?.sirenNumber}
                        />
                      </div>

                      <div className="col-span-12 xl:col-span-6">
                        <label>{t("partner.vat_number")} :</label>
                        <input
                          {...form.register("vatNumber")}
                          name="vatNumber"
                          type="text"
                          className="w-full"
                          defaultValue={partner.vatNumber}
                          aria-invalid={form.formState?.errors?.vatNumber}
                        />
                        <FieldError
                          error={
                            form.formState?.errors?.vatNumber ? true : false
                          }
                        />
                      </div>

                      <div className="col-span-12 xl:col-span-6">
                        <label>{t("partner.naf_code")} :</label>
                        <input
                          {...form.register("nafCode")}
                          name="nafCode"
                          type="text"
                          className="w-full"
                          defaultValue={partner.nafCode}
                          aria-invalid={
                            form.formState?.errors?.nafCode ? true : false
                          }
                        />
                        <FieldError error={form.formState?.errors?.nafCode} />
                      </div>

                      {authUser?.user?.roles.includes("ROLE_ADMIN") && (
                        <div className="col-span-12 xl:col-span-6">
                          <label>
                            {t("partner.internal_code")} <RequiredField /> :
                          </label>
                          <input
                            {...form.register("internalCode")}
                            name="internalCode"
                            type="text"
                            className="w-full"
                            defaultValue={partner.internalCode}
                            aria-invalid={
                              form.formState?.errors?.internalCode
                                ? true
                                : false
                            }
                          />
                          <FieldError
                            error={form.formState?.errors?.internalCode}
                          />
                        </div>
                      )}

                      <div className="col-span-12">
                        <label>{t("partner.website")} :</label>
                        <input
                          {...form.register("website")}
                          name="website"
                          type="text"
                          className="w-full"
                          defaultValue={partner.website}
                          aria-invalid={
                            form.formState?.errors?.website ? true : false
                          }
                        />
                        <FieldError error={form.formState?.errors?.website} />
                      </div>

                      <div className="col-span-12 pt-3">
                        <Button
                          className="btn btn-primary"
                          isloading={form.formState.isSubmitting}
                        >
                          {t("global.update")}
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <ContactsList partner={partner} setPartner={setPartner} />
              <AddressList partner={partner} setPartner={setPartner} />
            </>
          )}
        </div>
      </div>
    </Base>
  );
}

export default PartnersForm;
